import { render, staticRenderFns } from "./OpeningCardRecord.vue?vue&type=template&id=d57beee2"
import script from "./OpeningCardRecord.vue?vue&type=script&lang=js"
export * from "./OpeningCardRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports